import { render, staticRenderFns } from "./AdminBrand.vue?vue&type=template&id=3bff1cdb&scoped=true&"
import script from "./AdminBrand.vue?vue&type=script&lang=js&"
export * from "./AdminBrand.vue?vue&type=script&lang=js&"
import style0 from "./AdminBrand.vue?vue&type=style&index=0&id=3bff1cdb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bff1cdb",
  null
  
)

export default component.exports